const getHeight = (rootState) => rootState.ui.topbar.height;

export default getHeight;
